import { render, staticRenderFns } from "./SaOnlyProInfo.vue?vue&type=template&id=4dd43566&"
import script from "./SaOnlyProInfo.vue?vue&type=script&lang=js&"
export * from "./SaOnlyProInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports